(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    // Second photo on hover (audit 2026-10-15, Joel: "when you hover an image, it disappears for a second"): the hover photo
    // was lazy loaded, so it only started downloading on hover. Load it as soon as the card comes into view instead.
    if ('IntersectionObserver' in window && !window.atlHoverPreload) {
      window.atlHoverPreload = true;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target);
          e.target.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; }); });
      }, { rootMargin: '300px 0px' });
      var watch = function () { document.querySelectorAll('.card-gallery:not([data-atl-pre])').forEach(function (g) { g.setAttribute('data-atl-pre', '1'); io.observe(g); }); };
      var q = false, sched = function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; watch(); }); };
      watch(); document.addEventListener('DOMContentLoaded', watch); new MutationObserver(sched).observe(document.documentElement, { childList: true, subtree: true });
    }
    function cardImg(dot) { var card = dot.closest('.product-card, product-card, li, article'); return card && card.querySelector('.card-gallery img, img'); }
    document.addEventListener('mouseover', function (e) {
      var d = e.target.closest && e.target.closest('.atl-cdots i[data-img]'); if (!d) return;
      var img = cardImg(d); if (!img) return;
      if (!img.dataset.atlSrc) { img.dataset.atlSrc = img.getAttribute('src') || ''; img.dataset.atlSrcset = img.getAttribute('srcset') || ''; }
      img.removeAttribute('srcset'); img.src = d.dataset.img;
    });
    document.addEventListener('mouseout', function (e) {
      var box = e.target.closest && e.target.closest('.atl-cdots'); if (!box || (e.relatedTarget && box.contains(e.relatedTarget))) return;
      var img = cardImg(box); if (!img || !img.dataset.atlSrc) return;
      img.src = img.dataset.atlSrc; if (img.dataset.atlSrcset) img.setAttribute('srcset', img.dataset.atlSrcset);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
